import { useState, useRef, useEffect } from "react";
import { Table, Input, Typography, Select } from "antd";
import { EditFilled } from "@ant-design/icons";
import { useSpin } from "../../../components/SpinContext";
import { CheckOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { useToken } from "../../../common/helper";
import shipmentCount from "../../../assets/images/shipmentCount.svg";
import "./BulkUploadEditor.css";
import { CustomModalWithoutButton, CustomTitle } from "../../../components";
import { prepareCleanedPayload } from "./utils";
import { useBulkUploadData } from "./useBulkUploadData";
import BulkUploadFooter from "./BulkUploadEditorFooter";
import ErrorAlert from "./ErrorAlert";
import BulkFieldSelector from "./BulkFieldSelector";

const apiResponse = {
  header: [
    { key: "teams", value: "Teams" },
    { key: "reference_number", value: "Reference no." },
    { key: "courier", value: "Transport provider" },
    { key: "courier_tracking_id", value: "Tracking ID" },
    { key: "sensor", value: "Sensor" },
    { key: "sensor_tracking_id", value: "Sensor ID" },
    { key: "products", value: "Product(s)" },
    { key: "from_location", value: "Origin" },
    { key: "to_location", value: "Destination" },
    { key: "link_code", value: "Link Code" },

    {
      key: "ignore_sensor_measurement_at_start",
      value: "Ignore sensor measurement at start",
    },
  ],
  data: [
    {
      key: 0,
      status: "error",
      reference_number: {
        value: "REF001",
        error: "A shipment with this ID already exists",
      },
      courier: { value: "3a4ceea5-3bf5-493e-9c8b-b9d00e5bc4ac", error: "" },
      courier_tracking_id: { value: "TRK001", error: "" },
      sensor: { value: "87f76401-3f52-4d30-aa5f-c6d7182dc318", error: "" },
      sensor_tracking_id: { value: "SEN001", error: "" },
      products: {
        value: [
          "c6caeebb-5816-426a-a101-2c2ef4f4f30a",
          "bf059145-e350-46e0-9ef0-2728e69a1dde",
        ],
        error: "",
      },
      from_location: {
        value: "afea319d-aaf7-495d-9ca4-ae882ec24957",
        error: "",
      },
      to_location: { value: "afea319d-aaf7-495d-9ca4-ae882ec24957", error: "" },
      link_code: { value: "LC001", error: "" },
      ignore_sensor_measurement_at_start: { value: "100", error: "" },
      teams: {
        value: [
          "49ad488b-3e8c-4a84-ba4d-75b62b617f50",
          "b23a43c7-c862-4f89-8ca0-d9a7d2eccde4",
        ],
        color: "red",
        error: "",
      },
    },
    {
      key: 1,
      status: "error",
      reference_number: { value: "REF002", error: "" },
      courier: {
        value: "3a4ceea5-3bf5-493e-9c8b-b9d00e5bc4ac",
        error: "Courier not available in your region",
      },
      courier_tracking_id: { value: "TRK002", error: "" },
      sensor: { value: "87f76401-3f52-4d30-aa5f-c6d7182dc318", error: "" },
      sensor_tracking_id: { value: "SEN002", error: "" },
      products: { value: "c6caeebb-5816-426a-a101-2c2ef4f4f30a", error: "" },
      from_location: {
        value: "afea319d-aaf7-495d-9ca4-ae882ec24957",
        error: "",
      },
      to_location: { value: "afea319d-aaf7-495d-9ca4-ae882ec24957", error: "" },
      link_code: { value: "LC002", error: "" },
      ignore_sensor_measurement_at_start: { value: "120", error: "" },
      teams: { value: ["49ad488b-3e8c-4a84-ba4d-75b62b617f50"], error: "" },
    },
    {
      key: 2,
      status: "error",
      reference_number: { value: "REF003", error: "" },
      courier: { value: "3a4ceea5-3bf5-493e-9c8b-b9d00e5bc4ac", error: "" },
      courier_tracking_id: { value: "TRK003", error: "" },
      sensor: {
        value: "87f76401-3f52-4d30-aa5f-c6d7182dc318",
        error: "Sensor is not calibrated",
      },
      sensor_tracking_id: { value: "SEN003", error: "" },
      products: { value: "c6caeebb-5816-426a-a101-2c2ef4f4f30a", error: "" },
      from_location: {
        value: "afea319d-aaf7-495d-9ca4-ae882ec24957",
        error: "",
      },
      to_location: { value: "afea319d-aaf7-495d-9ca4-ae882ec24957", error: "" },
      link_code: { value: "LC003", error: "" },
      ignore_sensor_measurement_at_start: { value: "20", error: "" },
      teams: { value: ["49ad488b-3e8c-4a84-ba4d-75b62b617f50"], error: "" },
    },
    {
      key: 3,
      status: "error",
      reference_number: { value: "REF004", error: "" },
      courier: { value: "3a4ceea5-3bf5-493e-9c8b-b9d00e5bc4ac", error: "" },
      courier_tracking_id: { value: "TRK004", error: "" },
      sensor: { value: "87f76401-3f52-4d30-aa5f-c6d7182dc318", error: "" },
      sensor_tracking_id: { value: "SEN004", error: "" },
      products: {
        value: "c6caeebb-5816-426a-a101-2c2ef4f4f30a",
        error: "Product not approved for destination",
      },
      from_location: {
        value: "afea319d-aaf7-495d-9ca4-ae882ec24957",
        error: "",
      },
      to_location: { value: "afea319d-aaf7-495d-9ca4-ae882ec24957", error: "" },
      link_code: { value: "LC004", error: "" },
      ignore_sensor_measurement_at_start: { value: "10", error: "" },
      teams: { value: ["49ad488b-3e8c-4a84-ba4d-75b62b617f50"], error: "" },
    },
  ],
};
export default function BulkUploadEditor({
  totalShipments = 0,
  onCancel,
  fileData,
  unauthorize,
  totalRecords,
  onBackToStep1,
}) {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingFieldKey, setEditingFieldKey] = useState(null);
  const [bulkFieldValue, setBulkFieldValue] = useState(null);
  const { token, removeToken } = useToken();
  const [currentErrorCellIndex, setCurrentErrorCellIndex] = useState(0);
  const { showSpin, hideSpin } = useSpin();
  const {
    data,
    setData,
    couriersList,
    sensorsList,
    locationList,
    productList,
    allTeams,
  } = useBulkUploadData(token, fileData);

  const ignoreSensorTimes = Array.from({ length: 12 }, (_, i) => {
    const val = (i + 1) * 10;
    return { label: `${val} mins`, value: val };
  });
  const customTagRender = (props) => {
    const { label, value, closable, onClose } = props;
    const team = allTeams.find((t) => t.id === value);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          borderRadius: 4,
          padding: "2px 6px",
          marginRight: 4,
          marginBottom: 4,
        }}
      >
        <span
          style={{
            display: "inline-block",
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: team?.color || "#000",

            marginRight: 6,
          }}
        />
        <span style={{ fontSize: 12, marginRight: 6 }}>
          {team?.name || value}
        </span>
        {closable && (
          <span
            onClick={onClose}
            style={{ fontWeight: "bold", fontSize: 12, cursor: "pointer" }}
          >
            ×
          </span>
        )}
      </div>
    );
  };

  const inputRefs = useRef({});
  const errorCells = data.flatMap((row, rowIndex) =>
    Object.entries(row)
      .filter(([_, cell]) => typeof cell === "object" && cell.error)
      .map(([fieldKey]) => ({ rowIndex, fieldKey }))
  );
  const getErrorCount = () =>
    data.reduce(
      (count, row) =>
        count +
        Object.values(row).filter(
          (f) =>
            typeof f === "object" &&
            typeof f?.error === "string" &&
            f.error.trim() !== ""
        ).length,
      0
    );

  const goToError = (direction) => {
    const newIndex =
      direction === "up"
        ? Math.max(currentErrorCellIndex - 1, 0)
        : Math.min(currentErrorCellIndex + 1, errorCells.length - 1);

    const { rowIndex, fieldKey } = errorCells[newIndex];
    setCurrentErrorCellIndex(newIndex);

    setTimeout(() => {
      const targetRef = inputRefs.current?.[`${rowIndex}-${fieldKey}`];

      if (targetRef) {
        if (typeof targetRef.focus === "function") {
          targetRef.focus();
        }

        if (typeof targetRef.scrollIntoView === "function") {
          targetRef.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    }, 0);
  };
  const isRowValid = (row) =>
    Object.values(row).every(
      (field) =>
        typeof field !== "object" || !field.error || field.error.trim() === ""
    );
  const handleEditField = (fieldKey) => {
    setEditingFieldKey(fieldKey);
    setEditModalOpen(true);
    setBulkFieldValue();
  };

  const handleSave = () => {
    const isMultiSelect = ["teams", "products"].includes(editingFieldKey);

    const updated = data.map((item) => ({
      ...item,
      [editingFieldKey]: {
        ...item[editingFieldKey],
        value: bulkFieldValue,
        error: isMultiSelect
          ? Array.isArray(bulkFieldValue) && bulkFieldValue.length === 0
          : bulkFieldValue === "",
      },
    }));

    setData(updated);
    setEditModalOpen(false);
  };

  useEffect(() => {
    if (
      allTeams.length > 0 &&
      couriersList.length > 0 &&
      productList.length > 0 &&
      locationList.length > 0 &&
      sensorsList.length > 0
    ) {
      const updated = fileData?.data.map((row) => {
        const transformField = (
          fieldValue,
          list,
          keyLabel = "name",
          keyValue = "id"
        ) => {
          if (Array.isArray(fieldValue)) {
            return fieldValue.map((val) => {
              const item = list.find((i) => i[keyValue] === val);
              return { label: item?.[keyLabel] || val, value: val };
            });
          } else {
            const item = list.find((i) => i[keyValue] === fieldValue);
            return { label: item?.[keyLabel] || fieldValue, value: fieldValue };
          }
        };

        return {
          ...row,
          teams: {
            ...row.teams,
            value: transformField(
              row.teams?.value || [],
              allTeams,
              "name",
              "id"
            ),
          },
          courier: {
            ...row.courier,
            value: transformField(
              row.courier?.value,
              couriersList,
              "courier_name",
              "id"
            ),
          },
          sensor: {
            ...row.sensor,
            value: transformField(
              row.sensor?.value,
              sensorsList,
              "sensor_name",
              "id"
            ),
          },
          products: {
            ...row.products,
            value: transformField(
              row.products?.value || [],
              productList,
              "name",
              "id"
            ),
          },
          from_location: {
            ...row.from_location,
            value: transformField(
              row.from_location?.value,
              locationList,
              "name",
              "id"
            ),
          },
          to_location: {
            ...row.to_location,
            value: transformField(
              row.to_location?.value,
              locationList,
              "name",
              "id"
            ),
          },
          ignore_sensor_measurement_at_start: {
            ...row.ignore_sensor_measurement_at_start,
            value: Number(row.ignore_sensor_measurement_at_start?.value),
          },
        };
      });

      setData(updated);
    }
  }, [allTeams, couriersList, sensorsList, productList, locationList]);

  const columns = [
    {
      title: "",
      dataIndex: "statusIcon",
      key: "statusIcon",
      width: 40,
      render: (_, record) => {
        const hasError = Object.values(record).some(
          (field) =>
            typeof field === "object" &&
            typeof field?.error === "string" &&
            field.error.trim() !== ""
        );

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {hasError ? (
              <ExclamationCircleFilled
                style={{ color: "#DE1135", fontSize: 16 }}
              />
            ) : (
              <CheckOutlined style={{ color: "#AFAFAF", fontSize: 16 }} />
            )}
          </div>
        );
      },
    },
    ...fileData?.header.map(({ key, value }) => {
      const showAsterisk = [
        "courier",
        "courier_tracking_id",
        "products",
      ].includes(key);

      return {
        title: (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: 12, fontWeight: 500 }}>
              {value}
              {showAsterisk && (
                <span style={{ color: "#DE1135", marginLeft: 4 }}>*</span>
              )}
            </span>
            {!["reference_number", "courier_tracking_id"].includes(key) && (
              <EditFilled
                onClick={() => handleEditField(key)}
                style={{ fontSize: 14, color: "#888", cursor: "pointer" }}
              />
            )}
          </div>
        ),
        dataIndex: key,
        key,
        width: 240,
        render: (field, record, rowIndex) => {
          const inputKey = `${rowIndex}-${key}`;
          const isFocused =
            currentErrorCellIndex !== null &&
            errorCells[currentErrorCellIndex]?.rowIndex === rowIndex &&
            errorCells[currentErrorCellIndex]?.fieldKey === key;

          const hasError =
            typeof field?.error === "string" && field.error.trim() !== "";
          const className = `ant-input ${hasError ? "error-cell" : ""} ${
            isFocused ? "focus-error" : ""
          }`;

          const style = {
            height: 44,
            backgroundColor: hasError ? "#FFF0EE" : "transparent",
            padding: "0 8px",
            display: "flex",
            alignItems: "center",
            fontSize: 12,
          };

          const selectCommon = {
            size: "small",
            value: field?.value,
            style: { width: "100%" },
          };

          const selectOptions =
            key === "courier"
              ? couriersList.map((c) => ({
                  label: c.courier_name,
                  value: c.courier_name,
                }))
              : key === "sensor"
              ? sensorsList.map((s) => ({
                  label: s.sensor_name,
                  value: s.sensor_name,
                }))
              : key === "products"
              ? productList.map((p) => ({
                  label: p.name,
                  value: p.name,
                }))
              : ["from_location", "to_location"].includes(key)
              ? locationList.map((l) => ({
                  label: l.location_name || l.name || l.sensor_name,
                  value: l.location_name || l.name || l.sensor_name,
                }))
              : key === "ignore_sensor_measurement_at_start"
              ? ignoreSensorTimes
              : key === "teams"
              ? allTeams.map((t) => ({
                  label: t.name,
                  value: t.id,
                }))
              : [];

          const isSelectField = [
            "courier",
            "sensor",
            "products",
            "from_location",
            "to_location",
            "ignore_sensor_measurement_at_start",
            "teams",
          ].includes(key);

          return (
            <div
              style={{
                width: "100%",
                position: "relative",
                zIndex: isFocused && hasError ? 100 : "auto",
              }}
            >
              <div
                className={className}
                style={{
                  ...style,
                  border: hasError
                    ? "1px solid #DE1135"
                    : "1px solid transparent",
                  borderRadius: hasError ? "6px 6px 0 0" : "6px",
                  backgroundColor: hasError ? "#FFF0EE" : "transparent",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                {isSelectField ? (
                  <Select
                    suffixIcon={null}
                    {...selectCommon}
                    mode={
                      ["teams", "products"].includes(key)
                        ? "multiple"
                        : undefined
                    }
                    options={selectOptions}
                    ref={(node) => {
                      if (node) inputRefs.current[inputKey] = node;
                    }}
                    style={{ border: "none", width: "100%" }}
                    dropdownStyle={{ zIndex: 9999 }}
                    onFocus={() =>
                      setCurrentErrorCellIndex(
                        errorCells.findIndex(
                          (c) => c.rowIndex === rowIndex && c.fieldKey === key
                        )
                      )
                    }
                    onChange={(value) => {
                      const updated = [...data];
                      updated[rowIndex][key] = {
                        ...updated[rowIndex][key],
                        value,
                        error: "",
                      };
                      setData(updated);
                    }}
                    {...(key === "teams" && {
                      tagRender: customTagRender,
                      labelInValue: true,
                    })}
                  />
                ) : (
                  <Input
                    ref={(el) => (inputRefs.current[inputKey] = el)}
                    size="small"
                    value={field?.value}
                    onFocus={() =>
                      setCurrentErrorCellIndex(
                        errorCells.findIndex(
                          (c) => c.rowIndex === rowIndex && c.fieldKey === key
                        )
                      )
                    }
                    onChange={(e) => {
                      const updated = [...data];
                      updated[rowIndex][key] = {
                        ...updated[rowIndex][key],
                        value: e.target.value,
                        error: "",
                      };
                      setData(updated);
                    }}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                )}

                {/* Error message */}
                {hasError && isFocused && (
                  <span
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      backgroundColor: "#DE1135",
                      color: "#FFFFFF",
                      fontSize: 10,
                      lineHeight: "14px",
                      padding: "4px 6px",
                      borderRadius: "0 0 6px 6px",
                      zIndex: 9999,
                      marginTop: 2,
                      width: "100%",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {field.error}
                  </span>
                )}
              </div>
            </div>
          );
        },
      };
    }),
  ];

  return (
    <div className="bulk-upload-editor">
      <CustomTitle
        text="Bulk upload"
        fontSize="20px"
        lineHeight="28px"
        fontWeight="700"
        marginBottom="4px"
      />

      {editModalOpen && (
        <CustomModalWithoutButton
          modalOpen={editModalOpen}
          setModalOpen={setEditModalOpen}
          fontSize="20px"
          modalTextFontSize="14px"
          modalTitle={`Bulk assign ${editingFieldKey?.replace(/_/g, " ")}`}
          modalSize={447}
        >
          <BulkFieldSelector
            editingFieldKey={editingFieldKey}
            bulkFieldValue={bulkFieldValue}
            setBulkFieldValue={setBulkFieldValue}
            couriersList={couriersList}
            sensorsList={sensorsList}
            productList={productList}
            allTeams={allTeams}
            locationList={locationList}
            ignoreSensorTimes={ignoreSensorTimes}
            setEditModalOpen={setEditModalOpen}
            handleSave={handleSave}
          />
        </CustomModalWithoutButton>
      )}
      {getErrorCount() > 0 && <ErrorAlert />}

      <Table
        dataSource={data}
        columns={columns}
        rowKey={(row) => row.key}
        pagination={false}
        scroll={{ x: "max-content" }}
      />

      <BulkUploadFooter
        unauthorize={unauthorize}
        token={token}
        currentErrorCellIndex={currentErrorCellIndex}
        errorCells={errorCells}
        goToError={goToError}
        onBackToStep1={onBackToStep1}
        shipmentCount={shipmentCount}
        totalShipments={fileData?.created_count}
        totalRecords={fileData?.total_count}
        onCancel={onCancel}
        data={data}
        isRowValid={isRowValid}
        prepareCleanedPayload={prepareCleanedPayload}
        apiResponse={fileData}
        showSpin={showSpin}
        hideSpin={hideSpin}
      />
    </div>
  );
}
